export const ApiErrorMessage =
  'It’s not you, it’s us. Please refresh the page.';
export const WorkerAlreadyExistsError =
  'A worker with this last name, email and worker type combination already exists';
export const CompanyAlreadyExistsError =
  'A company with this name and email combination already exists';
export const InvalidTwoFACodeError =
  'The entered security code is invalid or expired. Please try again';
export const BillingWorkerAddressMismatchError =
  'Billing Address cannot be Worker Address';
